<div class="card mt-3">
  <div class="card-header text-uppercase">Tipo de Boleta</div>
  <div class="row mb-2 mb-3">
    <div class="col-6">
      <label for="subscriptionDate">Ação </label>
      <div class="form-check">
        <textarea
          [(ngModel)]="model.precedent"
          class="form-control"
          data-cy="precedent"
          rows="3"
          maxlength="250"
          name="precedent"
          disabled
        ></textarea>
      </div>
    </div>
    <div class="col-6">
      <label for="subscriptionDate">Parecerista Responsável</label>
      <div class="form-check">
        <select
          required
          class="form-control"
          id="operationType"
          [(ngModel)]="model.reviewerGroupId"
          name="operationType"
          disabled
        >
          <option *ngFor="let item of reviewersList" [value]="item.groupId">
            {{ item.groupName }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-6">
      <label for="subscriptionDate">Email do responsável </label>
      <div class="form-check">
        <input
          type="text"
          class="form-control"
          data-cy="precedent"
          name="precedent"
          [(ngModel)]="model.email"
          disabled
        />
      </div>
    </div>

    <div class="col-6">
      <label for="subscriptionDate">Status da operação</label>
      <div class="form-check">
        <select
          required
          class="form-control"
          id="operationType"
          [(ngModel)]="model.precedentStatus"
          name="operationType"
          [disabled]="!isCreatorPrecedent(model)"
        >
          <option [value]="1">Aprovado</option>
          <option [value]="2">Reprovado</option>
          <option [value]="3">Não se aplica mais</option>
          <option [value]="4">Aguardando</option>
        </select>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div class="table-container" *ngIf="Files.length > 0">
      <table mat-table [dataSource]="Files" class="col-md-12">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createDate">
          <th mat-header-cell *matHeaderCellDef>Data de Criação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.creationDate | date: "dd/MM/yyyy HH:mm:ss" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createUser">
          <th mat-header-cell *matHeaderCellDef>Usuário de Criação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.creationUser }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let element; let i = index" class="actions">
            <div style="padding-left: 20px; padding-top: 15px">
              <a *ngIf="isValidFile(element.name)" (click)="openPdf(element.name)">
                <fa-icon [icon]="faEye" style="color: rgb(22, 175, 43)"></fa-icon>
              </a>
              <a (click)="download(element.name)">
                <fa-icon [icon]="faDownload" style="color: blue"></fa-icon>
              </a>
              <th mat-header-cell *matHeaderCellDef></th>
            </div>
            <br />
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="ColumnsFile; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsFile"></tr>
      </table>
    </div>
    <div class="button">
      <input
        type="button"
        value="Salvar"
        class="btn-margin btn btn-primary"
        appDebounceClick
        (debounceClick)="createPrecedent(model)"
        [debounceTime]="200"
        data-cy="submit"
      />
    </div>
  </div>
</div>
